<template>
	<div class="cases-nav pa-content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
		<div class="container">
			<el-row>
				<el-col :xs="24" :md="8" v-for="(item, index) in caselist" :key="index">
					<div class="case-list wow animate__animated animate__fadeInUp animate__delay-0.3s">
						<div class="case-list-img">
							<img :src="item.url"></img>
							<span class="img-local">
								<img src="../../static/images/case/icon4.png" class="icon-img" alt="">
								<b>{{ item.address }}</b>
							</span>
						</div>
						<div class="case-list-info">
							<h3 class="ws">{{ item.name }}</h3>
							<div class="ws">
								<img src="../../static/images/case/icon1.png" class="icon-img" alt="">
								<span>{{ langs.case1 }}：<b class="case-system">{{ item.system }}</b></span>
							</div>
							<div class="ws">
								<img src="../../static/images/case/icon2.png" class="icon-img" alt="">
								<span>{{ langs.case2 }}：<b class="case-size">{{ langs.case3 }}</b></span>
							</div>
							<div class="ws">
								<img src="../../static/images/case/icon3.png" class="icon-img" alt="">
								<span>{{ langs.case4 }}：<b class="case-color">{{ langs.case3 }}</b></span>
							</div>
						</div>
						<div class="case-list-btn">
							<router-link class="dtl-btn" :to="{name:'casedetail', query:{id:index}}" >
								<el-button>{{ langs.case5 }}</el-button>
							</router-link>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		data() {
			return {
				showLoading: true,

				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,
				caselist: [],
				caselist1: [
					{
						url: require('../../static/images/case/1.png'),
						address: '西藏 - 拉萨',
						name: '智能快递柜',
						system: '智能快递柜',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/2.png'),
						address: '山东 - 青岛',
						name: 'RFID智能柜',
						system: 'RFID智能柜',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/3.png'),
						address: '广东 - 深圳',
						name: '智能存包柜',
						system: '智能存包柜',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/4.png'),
						address: '浙江 - 杭州',
						name: '智能洗衣柜',
						system: '智能洗衣柜',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/5.png'),
						address: '上海',
						name: '智能取餐柜',
						system: '智能取餐柜',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/6.png'),
						address: '陕西 - 西安',
						name: '智能快递柜',
						system: '智能快递柜',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/7.png'),
						address: '浙江 - 杭州',
						name: '智能售货机',
						system: '售货机系统',
						size: 'w1920mm*h1800mm*D450mm',
						color: '蓝白'
					},
					{
						url: require('../../static/images/case/8.png'),
						address: '上海',
						name: '美妆售货机',
						system: '售货机系统',
						size: 'w1920mm*h1800mm*D450mm',
						color: '支持定制'
					},
				],
				caselist2: [
					{
						url: require('../../static/images/case/1.png'),
						address: 'Lhasa',
						name: 'Smart express cabinet',
						system: 'Smart express cabinet',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/2.png'),
						address: 'Qingdao',
						name: 'RFID Smart cabinet',
						system: 'RFID Smart cabinet',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/3.png'),
						address: 'Shenzhen',
						name: 'Smart bag storage cabinet',
						system: 'Smart bag storage cabinet',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/4.png'),
						address: 'Hangzhou',
						name: 'Smart washing cabinet',
						system: 'Smart washing cabinet',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/5.png'),
						address: 'Shanghai',
						name: 'Smart save meal cabinet',
						system: 'Smart save meal cabinet',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/6.png'),
						address: "Xi 'an",
						name: 'Smart express cabinet',
						system: 'Smart express cabinet',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/7.png'),
						address: 'Hangzhou',
						name: 'Intelligent vending machine',
						system: 'Vending machine system',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Blue and white'
					},
					{
						url: require('../../static/images/case/8.png'),
						address: 'Shanghai',
						name: 'Beauty vending machine',
						system: 'Vending machine system',
						size: 'w1920mm*h1800mm*D450mm',
						color: 'Support customization'
					},
				],
        caselist3: [
          {
            url: require('../../static/images/case/1.png'),
            address: 'Tíbet - Lhasa',
            name: 'Gabinete expreso inteligente',
            system: 'Gabinete expreso inteligente',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/2.png'),
            address: 'Qingdao, Shandong',
            name: 'Gabinete inteligente RFID',
            system: 'Gabinete inteligente RFID',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/3.png'),
            address: 'Shenzhen, Cantón',
            name: 'Taquilla inteligente',
            system: 'Taquilla inteligente',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/4.png'),
            address: 'Hangzhou, Zhejiang',
            name: 'Mueble de lavandería inteligente',
            system: 'Mueble de lavandería inteligente',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/5.png'),
            address: 'Llevar a la fuerza',
            name: 'Mueble de comedor inteligente',
            system: 'Mueble de comedor inteligente',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/6.png'),
            address: 'Shanxi - Xi`an',
            name: 'Gabinete expreso inteligente',
            system: 'Gabinete expreso inteligente',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/7.png'),
            address: 'Hangzhou, Zhejiang',
            name: 'Máquina expendedora inteligente',
            system: 'sistema de venta',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'azul y blanco'
          },
          {
            url: require('../../static/images/case/8.png'),
            address: 'Llevar a la fuerza',
            name: 'Máquina expendedora de belleza',
            system: 'sistema de venta',
            size: 'w1920mm*h1800mm*D450mm',
            color: 'Personalización de soporte'
          },
        ],
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated）
					offset: 0,//到元素距离触发动画（当默认为0）
					mobile: true, //在移动设备上触发动画（默认为true）
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})
			_this.currlangs = sessionStorage.getItem('UPUS_langs');

			if(_this.currlangs == 2) {
				_this.langs = sp;
				_this.caselist = _this.caselist3;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
				_this.caselist = _this.caselist2;
			} else {
				_this.langs = zh;
				_this.caselist = _this.caselist1;
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.cases-nav{
		background-color: #f5f5f5;
	}
	.cases-nav .el-col{
		padding: 20px 30px;
	}
	.case-list{
		background-color: #fff;
	}
	.case-list .icon-img{
		width: 15px;
		float: left;
		margin: 4px 6px 0px 0px;
	}
	.case-list-img{
		position: relative;
	}
	.img-local{
		position: absolute;
		right: 0px;
		bottom: 3px;
		padding: 4px 12px;
		background-image: url(../../static/images/case/bluebg.png);
	}
	.case-list .img-local .icon-img{
		width: 10px;
	}
	.case-system{
		font-size: 16px;
		color: #409EFF;
	}
	.case-list-info{
		padding: 0px 20px;
	}
	.case-list-info div{
		margin: 8px 0px;
	}
	.case-list-info b{
		font-weight: 100;
	}
	.case-list-btn{
		margin: 20px auto;
		text-align: center;
		padding-bottom: 20px;
	}
	.case-list-btn .el-button{
		padding: 10px 45px;
	}
	.case-size, .case-color{
		color: #888;
	}
</style>



// WEBPACK FOOTER //
// src/views/casesNav.vue